/**
 * Copy of the one product search (refonte WP-37 / cross-module XWP-12; design ux/04 §3.2, §7.1;
 * DECISIONS A-11). French UI strings only — no rule lives here. The matched-field and tier labels are
 * keyed by the server payload's `pertinence.champs[]` / `pertinence.niveau` values
 * (packages/shared/search/cle.js CHAMPS_PRODUIT, constantes.js NIVEAU_PERTINENCE).
 */

export const RECHERCHE_PRODUIT_COPIE = Object.freeze({
  placeholderPos: "Nom, DCI, code-barres, N° ENR…",
  placeholderRemplacement: "Rechercher le produit de remplacement…",
  label: "Rechercher un produit",
  enCours: "Recherche…",
  aideMatching: "La recherche ignore les accents, la casse et l'ordre des mots ; un code-barres ou un N° ENR complet est trouvé exactement.",
  aucunDisponible: (q) => `Aucun produit ne correspond à « ${q} »`,
  aucunCatalogue: (q) => `Aucun produit du catalogue ne correspond à « ${q} »`,
  signalerDemande: (q) => `Signaler une demande pour « ${q} »`,
  creerFiche: (q) => `Créer la fiche « ${q} »`,
  demandeResponsable: (q) => `…ou seulement signaler une demande au responsable pour « ${q} »`,
  aChoisir: "Plusieurs produits correspondent : choisissez avec ↑ ↓ puis Entrée.",
  echec: "La recherche a échoué.",
  reessayer: "Réessayer",
  // availability of a POS row (§14.3 « Non disponible », XWP-03 sellable figure)
  bloque: "Bloqué",
  enReserve: "En réserve — autre magasin",
  rupture: "Rupture",
  ruptureDemande: "Rupture — Entrée signale une demande",
  ruptureIndisponible: "Rupture — indisponible",
  venteLibreBloquee: "Vente libre bloquée",
  psychotrope: "Psychotrope · Liste I / Tableau B",
  stock: (n) => `Stock : ${n}`,
  emplacement: (codes) => `Empl. ${codes}`,
  // X XWP-96 (brief 2026-10-26 §2) — the FEFO-first counter lot and the other visible lots
  lotFefo: (numero, mmaa) => `Lot ${numero ?? "—"}${mmaa ? ` · Pér. ${mmaa}` : ""}`,
  autresLots: (n) => `+ ${n} autre${n > 1 ? "s" : ""} lot${n > 1 ? "s" : ""}`,
  // X XWP-98 (XO-25) — a lot row made of several identical receptions (P / M only — the server never tells a caissier)
  receptions: (n) => `${n} réceptions`,
  cnas: "CNAS",
  peremption: (mmaa) => `Pér. ${mmaa}`,
  numeroEnr: (n) => `N° ENR ${n}`,
});

/** `pertinence.niveau` → the tier word shown when it explains the hit (ux/04 §3.1 T0 / T4). */
export const LIBELLE_NIVEAU = Object.freeze({
  EXACT: "Code exact",
  PROCHE: "Orthographe proche",
});

/** `pertinence.champs[]` key → the field name of the « Trouvé par » explanation (ux/04 §3.2). */
export const LIBELLE_CHAMP = Object.freeze({
  nom_commercial: "nom",
  dci: "DCI",
  laboratoire: "laboratoire",
  marque: "marque",
  forme: "forme",
  dosage: "dosage",
  conditionnement: "conditionnement",
  num_enr_cnas: "N° ENR",
  codes_barre: "code-barres",
});

/** The generics tier (XWP-11 / A-12 vocabulary): a hit found by its DCI only. */
export const LIBELLE_GENERIQUE_DCI = "Même DCI";
